import { motion } from "framer-motion";

const ease = [0.16, 1, 0.3, 1];

// Masked line-by-line reveal for hero headlines.
// Pass `lines` as an array of strings (or JSX).
export default function KineticText({ lines = [], className = "", delay = 0.1, stagger = 0.12 }) {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="line-mask">
          <motion.span
            style={{ display: "block" }}
            initial={{ y: "110%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 0.9, ease, delay: delay + i * stagger }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
}
